module.exports = __webpack_public_path__ + "img/hero-daddy-academy.c8d81c39.png";